import {Button, Stack, Typography} from '@mui/material';
import {Component, type ErrorInfo, type ReactNode} from 'react';

type Props = {
    children: ReactNode;
};

type State = {
    hasError: boolean;
};

class ErrorBoundary extends Component<Props, State> {
    public state: State = {hasError: false};

    public static getDerivedStateFromError(): State {
        return {hasError: true};
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        console.error('unhandled application error', error, errorInfo);
    }

    public render(): ReactNode {
        if (!this.state.hasError) {
            return this.props.children;
        }

        return (
            <Stack
                sx={{
                    height: '100vh',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#fff',
                    px: 2,
                }}
            >
                <Typography variant='h6' sx={{mb: 2, textAlign: 'center'}}>
                    Something went wrong while loading this page.
                </Typography>
                <Typography sx={{mb: 3, textAlign: 'center'}}>
                    Please reload the page. If the problem continues, contact the Enrollment
                    Office at (847) 486-4677.
                </Typography>
                <Button
                    color='secondary'
                    variant='outlined'
                    onClick={() => {
                        window.location.reload();
                    }}
                >
                    Reload
                </Button>
            </Stack>
        );
    }
}

export default ErrorBoundary;
